import { useState } from "react";
import { IPaginationPayload } from "../../../interfaces/shared/IPaginationPayload";
import { useGetAllCallsQuery } from "../../../store/reservations/reservationsApi";
import CallsTable from "./tables/CallsTable";

const Calls = () => {
  const [paginationState, setPaginationState] = useState<IPaginationPayload>({
    pageNumber: 1,
    pageSize: 10,
  });
  const { data, isLoading } = useGetAllCallsQuery(paginationState);

  return (
    <div className="flex flex-wrap">
      <div className="w-full">
        <h2 className="page-title">Calls</h2>
        <CallsTable
          rows={data?.data?.elements || []}
          paginationData={data?.data.page}
          rowsLoading={isLoading}
          setPaginationState={setPaginationState}
        />
      </div>
      {/* <div className="w-full lg:w-5/12 xl:w-4/12 px-4">
        <div className="bg-white p-4">
          <h2 className="text-[#5D6679] text-base mb-2">Calls form</h2>
          <div className="bg-[#F9F9F9] rounded-lg px-4 py-6">
			<CreateCall />
		  </div>
        </div>
      </div> */}
    </div>
  );
};

export default Calls;
